const gridletsDirectives = angular.module('gridlets-directives.module', []);

gridletsDirectives.directive('gridlets', function(
  gridletService,
  $timeout,
  eventService
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/gridlets-module.html',
    scope: {
      view: '=',
      customizable: '=',
      filter: '=',
    },
    controller: [
      '$scope',
      '$uibModal',
      'eventService',
      function($scope, $uibModal, eventService) {
        $scope.$on('repeat-finished', function() {
          $scope.$broadcast('gridlet-init');
          eventService.broadcast('gridster-ready');
        });
      },
    ],
    link: function(scope) {
      scope.gridlets = [];
      const forceReload = false;
      gridletService.getGridlets(scope.view, forceReload).then(function(gridlets) {
        $timeout(function() {
          $timeout(function() {
            scope.gridlets = angular.copy(gridlets);
            if (gridlets.length === 0) scope.$broadcast('repeat-finished');
          }, 0);
        }, 0);
      });
      scope.$on('update-gridlet-list', function() {
        const forceReload = false;
        gridletService.getGridlets(scope.view, forceReload).then(function(gridlets) {
          $timeout(function() {
            $timeout(function() {
              scope.gridlets = angular.copy(gridlets);
            }, 0);
          }, 0);
        });
      });
      //to update menu list
      scope.$on('update-gridlet-list', function() {
        eventService.broadcast('update-gridlet-menu');
      });

      scope.$on('restore-default-widgets', function() {
        let view = scope.view;
        gridletService.restoreDefaultGridlets().then(function() {
          const forceReload = true;
          gridletService.getGridlets(view, forceReload).then(function(gridlets) {
            $timeout(function() {
              $timeout(function() {
                scope.gridlets = angular.copy(gridlets);
              }, 0);
            }, 0);
          });
        });

      });
      scope.$on('restore-default-widgets', function() {
        eventService.broadcast('update-gridlet-menu');
      });

      scope.gridsterOpts = {
        margins: [8, 8],
        rows: 10,
        columns: 10,
        pushing: true,
        floating: false,
        swapping: false,
        colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
        rowHeight: '150', //$scope.gridletRowHeight, // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets. 230
        maxRows: 20,
        minSizeX: 2,
        minSizeY: 2,
        resizable: {
          enabled: true,
          handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw'],
          start: function(event, el) {
            eventService.broadcast('gridlet-resize-started', el);
          },
          stop: function(event, el) {
            eventService.broadcast('gridlet-resize-stopped', el);
          },
        },
        draggable: {
          enabled: true,
          handle: '.gridletTitleRow',
          start: function(event, el) {
            eventService.broadcast('gridlet-dragging-started', el);
          },
          stop: function(event, el) {
            eventService.broadcast('gridlet-dragging-stopped', el);
          },
        },
        mobileBreakPoint: 400,
        mobileModeEnabled: true,
      };

      scope.$watch('customizable', function(value) {
        scope.gridsterOpts.resizable.enabled = value;
        scope.gridsterOpts.draggable.enabled = value;
      });
    },
  };
});
